/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { SuccessRateByVersionRowFromJSON, SuccessRateByVersionRowToJSON } from './SuccessRateByVersionRow';
/**
 * Check if a given object implements the SuccessRateByVersionResponse interface.
 */
export function instanceOfSuccessRateByVersionResponse(value) {
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('hoursSinceLastEventEver' in value) || value['hoursSinceLastEventEver'] === undefined)
        return false;
    if (!('versions' in value) || value['versions'] === undefined)
        return false;
    return true;
}
export function SuccessRateByVersionResponseFromJSON(json) {
    return SuccessRateByVersionResponseFromJSONTyped(json, false);
}
export function SuccessRateByVersionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'days': json['days'],
        'hoursSinceLastEventEver': json['hoursSinceLastEventEver'],
        'versions': (mapValues(json['versions'], SuccessRateByVersionRowFromJSON)),
    };
}
export function SuccessRateByVersionResponseToJSON(json) {
    return SuccessRateByVersionResponseToJSONTyped(json, false);
}
export function SuccessRateByVersionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'days': value['days'],
        'hoursSinceLastEventEver': value['hoursSinceLastEventEver'],
        'versions': (mapValues(value['versions'], SuccessRateByVersionRowToJSON)),
    };
}
